import styled from 'styled-components'

export const ContainerBio = styled.section`
  width: 100%;
  height: calc(100% - 10px);
  box-sizing: border-box;
  padding: 5px;
  h1 {
    font-weight: 700;
    font-size: 18px;
    color: var(--text-color);
  }
`

export const CampoPrincipal = styled.section`
  width: 100%;
  background-color: white;
  border: thin solid var(--border-color);
  border-radius: 10px;
  box-sizing: border-box;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  .header__cadastrar {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 5px;
  }
  .title__header {
    font-size: 18px;
    font-weight: bold;
  }

  .camp__add {
    width: 50%;
    display: flex;
  }

  .btn__register {
    background-color: var(--primary-color);
  }

  .camp__search {
    width: 50%;
    margin-left: 5px;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
  }

  .input__search {
    height: 100%;
    width: 90%;
    border-radius: 10px;
    border-bottom: none;
    border-top: none;
    border-left: none;
    border-right: none;
  }
`

export const TabelaBiotecnologia = styled.div`
  width: 100%;
  height: calc(100% - 90px);
  background-color: white;
  border-radius: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 5px;

 
`